import * as React from 'react';
import CustomDiagnosticsPanel from './CustomDiagnosticsPanel';
import DiagnosticsTable from './DiagnosticsTable';
import NetworkDiagnosticsPanel from './NetworkDiagnosticsPanel';
import setSelectedPivot from '../mutators/setSelectedPivot';
import { getDiagnosticsLogState } from '../store/store';
import { observer } from 'mobx-react';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Pivot, PivotItem, PivotLinkFormat, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import { DiagnosticsLogger } from '../store/schema/DiagnosticsLogState';

let styles = require('./DiagnosticsPanel.scss');

export interface DiagnosticsPanelProps {
    onDismiss: () => void;
}

@observer
export default class DiagnosticsPanel extends React.Component<DiagnosticsPanelProps, {}> {
    renderPanel(loggerKey: string, logger: DiagnosticsLogger<any>) {
        switch (logger && logger.type) {
            case 'ServiceRequest':
                return <NetworkDiagnosticsPanel key={loggerKey} logger={logger} />;
            case 'Custom':
                return <CustomDiagnosticsPanel key={loggerKey} logger={logger} />;
            default:
                return (
                    <DiagnosticsTable
                        key={loggerKey}
                        header={logger.header}
                        datapoints={logger.datapoints}
                    />
                );
        }
    }

    private selectPivot = (item: PivotItem) => {
        setSelectedPivot(item.props.itemKey);
    };

    render() {
        let { onDismiss } = this.props;
        let logState = getDiagnosticsLogState().loggers;
        let items = [];
        logState.forEach((logger, loggerKey) => {
            items.push(
                <PivotItem key={loggerKey} itemKey={loggerKey} headerText={loggerKey}>
                    {this.renderPanel(loggerKey, logState.get(loggerKey))}
                </PivotItem>
            );
        });
        return (
            <Panel
                className={styles.main}
                type={PanelType.large}
                isLightDismiss={true}
                isOpen={true}
                isBlocking={false}
                hasCloseButton={true}
                onDismiss={onDismiss}>
                <Pivot
                    selectedKey={getDiagnosticsLogState().selectedPivotKey}
                    onLinkClick={this.selectPivot}
                    linkFormat={PivotLinkFormat.tabs}
                    linkSize={PivotLinkSize.large}>
                    {items}
                </Pivot>
            </Panel>
        );
    }
}
